import Box from "@/components/Box";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";

import CircleButton from "../CircleButton";
import { ReportListCardMarkerItem } from "./MarkerItem";

export function ReportListCardMarkersAssessed({
  functionalDatapointCount,
  userReportFunctionalDatapointCount,
  dnaDatapointCount,
  userReportDnaDatapointCount,
  symptomsCount,
  userReportSymptomsCount,
  color = "dark",
  layout = "stack",
  showCircleButton = true,
  showHeading = true,
  sx
}) {
  const markers = (
    <>
      <ReportListCardMarkerItem
        type="functional"
        count={functionalDatapointCount}
        userCount={userReportFunctionalDatapointCount}
        color={color}
      />
      <ReportListCardMarkerItem
        type="dna"
        count={dnaDatapointCount}
        userCount={userReportDnaDatapointCount}
        color={color}
      />
      <ReportListCardMarkerItem
        type="symptoms"
        count={symptomsCount}
        userCount={userReportSymptomsCount}
        color={color}
      />
    </>
  );

  if (layout === "inline") {
    return (
      <Group width="100%" alignItems="center" gap={16} {...sx}>
        <Group gap={16} flexWrap="wrap" alignItems="center" flex={1} minWidth={0}>
          {showHeading && (
            <Box
              fontFamily="gilroyBold"
              fontSize={[14, 14, 16]}
              lineHeight={["24px", "24px", "28px"]}
              color={color}
            >
              Markers assessed:
            </Box>
          )}
          {markers}
        </Group>
        {showCircleButton ? <CircleButton sx={{ flexShrink: 0, ml: "auto" }} /> : null}
      </Group>
    );
  }

  return (
    <Stack gap={8} mt="auto" pt={20} {...sx}>
      {showHeading && (
        <Box
          fontFamily="gilroyBold"
          fontSize={[14, 14, 16]}
          lineHeight={["24px", "24px", "28px"]}
          color={color}
        >
          Markers assessed
        </Box>
      )}
      <Group
        justifyContent="space-between"
        alignItems={layout === "group" ? "center" : "flex-start"}
      >
        {layout === "group" ? (
          <Group gap={16} flexWrap="wrap">
            {markers}
          </Group>
        ) : (
          <Stack gap={8}>{markers}</Stack>
        )}
        {showCircleButton ? <CircleButton sx={{ mt: "auto" }} /> : null}
      </Group>
    </Stack>
  );
}
